/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserProfileImage } from './userProfileImage';


export interface AdminLocationDepartmentContactsContactsInner { 
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    type: AdminLocationDepartmentContactsContactsInner.TypeEnum;
    /**
     * 
     */
    subscriptionId: number;
    /**
     * 
     */
    userId: number;
    /**
     * 
     */
    startDate?: string;
    /**
     * 
     */
    endDate?: string;
    /**
     * 
     */
    firstname?: string;
    /**
     * 
     */
    lastname?: string;
    /**
     * 
     */
    email: string;
    /**
     * 
     */
    titleDescr?: string;
    profileImage?: UserProfileImage;
}
export namespace AdminLocationDepartmentContactsContactsInner {
    export type TypeEnum = 'internship-evaluation-interuniversity' | 'supervisor-quality-survey';
    export const TypeEnum = {
        InternshipEvaluationInteruniversity: 'internship-evaluation-interuniversity' as TypeEnum,
        SupervisorQualitySurvey: 'supervisor-quality-survey' as TypeEnum
    };
}


